<template>
  <AGExpansionPanel
    v-if="showMatrizExposicao"
    class="ag-autocomplete-grau-risco__expansion-panel"
    expand-text-close="Ocultar matriz e legenda"
    expand-text-open="Exibir matriz e legenda"
    direction="vertical"
    dense
    hide-separator
    :model-value="false"
  >
    <template #actions>
      <AGIcon icon="md:help" lib="md" size="small" />
    </template>
    <template #header>
      <AGAutocomplete
        id="autocomplete_grau_risco"
        v-model="localValue"
        class="ag-autocomplete-grau-risco__autocomplete"
        label="Grau de risco"
        :clearable="clearable"
        :items="items"
        :hint="hint"
        :disabled="disabled"
        :multiple="multiple"
        :has-select-all="hasSelectAll"
        :has-select-group="hasSelectGroup"
        :rules="rules"
      />
    </template>
    <template #content>
      <AGCard class="ag-autocomplete-grau-risco__matriz-exposicao" borderless has-rounded-top has-rounded-bottom>
        <AGMatrizExposicaoTabela />
        <AGMatrizExposicaoLegenda />
      </AGCard>
    </template>
  </AGExpansionPanel>

  <AGAutocomplete
    v-else
    id="autocomplete_nivel_risco"
    v-model="localValue"
    label="Grau de risco"
    :clearable="clearable"
    :items="items"
    :hint="hint"
    :disabled="disabled"
    :multiple="multiple"
    :has-select-all="hasSelectAll"
    :has-select-group="hasSelectGroup"
    :rules="rules"
  />
</template>

<script>
import AGAutocomplete from '@/components/common/AGAutocomplete.vue';
import AGCard from '@/components/common/AGCard.vue';
import AGExpansionPanel from '@/components/common/AGExpansionPanel.vue';
import AGIcon from '@/components/common/AGIcon.vue';
import AGMatrizExposicaoLegenda from '@/components/common/risco/AGMatrizExposicaoLegenda.vue';
import AGMatrizExposicaoTabela from '@/components/common/risco/AGMatrizExposicaoTabela.vue';

export default {
  components: {
    AGAutocomplete,
    AGCard,
    AGExpansionPanel,
    AGIcon,
    AGMatrizExposicaoLegenda,
    AGMatrizExposicaoTabela,
  },
  emits: ['update:modelValue'],
  props: {
    modelValue: {
      type: [Boolean, String, Number, Array, Object],
      default: '',
    },
    showMatrizExposicao: {
      type: Boolean,
      default: false,
    },
    hint: {
      type: String,
      default: '',
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    rules: {
      type: Array,
      default: () => [],
    },
    hasSelectAll: {
      type: Boolean,
      default: false,
    },
    hasSelectGroup: {
      type: Boolean,
      default: false,
    },
    showNoRisk: {
      type: Boolean,
      default: false,
    },
    showEmAnalise: {
      type: Boolean,
      default: false,
    },
    clearable: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    localValue: {
      get() {
        return this.modelValue;
      },
      set(val) {
        this.$emit('update:modelValue', val);
      },
    },
    items() {
      const NIVEL_RISCO = {
        BAIXO: { title: 'Baixo', groupId: 'TODOS_OS_RISCOS', show: true },
        MODERADO: { title: 'Moderado', groupId: 'TODOS_OS_RISCOS', show: true },
        ELEVADO: { title: 'Elevado', groupId: 'TODOS_OS_RISCOS', show: true },
        CRITICO: { title: 'Crítico', groupId: 'TODOS_OS_RISCOS', show: true },
        INEXPRESSIVO: { title: 'Inexpressivo', groupId: 'TODOS_OS_RISCOS', show: this.showNoRisk },
        EM_ANALISE: { title: 'Em análise', show: this.showEmAnalise },
      };

      return Object.keys(NIVEL_RISCO)
        .filter((key) => NIVEL_RISCO[key].show)
        .map((key) => ({
          id: key,
          value: key,
          title: NIVEL_RISCO[key].title,
          groupId: this.showNoRisk ? NIVEL_RISCO[key].groupId : null,
          isGroup: NIVEL_RISCO[key].isGroup,
        }));
    },
  },
};
</script>

<style lang="scss" scoped>
.ag-autocomplete-grau-risco {
  &__autocomplete {
    width: 100%;
  }

  &__matriz-exposicao {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }
}
</style>
